module.exports = __webpack_public_path__ + "img/Aeschines_British_Museum.eff6563b.png";